let OPEN_MENU = 'open_menu'
let ADD_MENU = 'add_menu'
let LOG_IN = "log_in"
let LOG_OUT = "log_out"
let DrawerControl= "draw_control"
let RainfallDataUpdate = 'rainfallupdate'

export const aAction_open_menu = {
    type: OPEN_MENU
}

export const aAction_add_menu = ((id) => {
    return ({
        type: ADD_MENU,
        id: id
    })
})

export const aLogin = {
	type: LOG_IN
}

export const aLogout = {
	type: LOG_OUT
}

export const aDrawer = ((open) => {
	return({
		type: DrawerControl,
		open: open
	})
})

export const aRainfallData = ((data)=>{
	return({
		type: RainfallDataUpdate,
		data: data
	})
})


// WEBPACK FOOTER //
// ./src/redux/actions.js